import { SearchNormal1 } from "iconsax-react";
import GenericCompanyImage from "../../../components/GenericCompanyImage/GenericCompanyImage";
import InfoField from "../../../components/InfoField/InfoField";
import InfoFieldBox from "../../../components/InfoFieldBox/InfoFieldBox";
import Modal from "../../../components/Modal/Modal";
import { useStore } from "../../../store/useStore";
import { Colors } from "../../../utils/constants/style";
import {
  formatCEP,
  formatCNPJ,
  formatDateTime,
  formatTitleCase,
} from "../../../utils/functions/formatters";
import { Map } from "@vis.gl/react-google-maps";
import HotspotPositionMarker from "../../Dashboard/Map/HotspotPositionMarker";

interface DetailsCompanyModalProps {
  onClose: () => void;
}

const DetailsCompanyModal: React.FC<DetailsCompanyModalProps> = ({
  onClose,
}) => {
  const selectedCompany = useStore((state) => state.company.selectedCompany);
  const isLoadingCompany = useStore((state) => state.company.isLoadingCompany);

  return (
    <Modal
      title="Detalhes da empresa"
      icon={<SearchNormal1 size="30" color={Colors.white} variant="Linear" />}
      className="min-w-[750px]"
      onClose={onClose}
    >
      <div className="flex flex-col gap-8 mt-5">
        <div className="flex gap-10">
          <div>
            <GenericCompanyImage
              logo={selectedCompany?.logo}
              width={100}
              height={100}
              loading={isLoadingCompany}
            />
          </div>
          <div className="flex flex-col justify-between h-[100px]">
            <InfoField
              loading={isLoadingCompany}
              label="Nome"
              content={selectedCompany?.name}
            />
            <InfoField
              loading={isLoadingCompany}
              label="CNPJ"
              content={formatCNPJ(selectedCompany?.cnpj ?? "")}
            />
          </div>
        </div>
        <InfoFieldBox>
          <InfoField
            loading={isLoadingCompany}
            label="Localização"
            content={
              <>
                {formatTitleCase(`${selectedCompany?.address?.street.toString()}, ${selectedCompany?.address?.neighbourhood}, ${selectedCompany?.address?.number} - ${selectedCompany?.address?.city}`)}/{selectedCompany?.address?.state}
                <br />
                {formatCEP(selectedCompany?.address?.zipcode.toString())} - {formatTitleCase(selectedCompany?.address?.neighbourhood)} - {formatTitleCase(selectedCompany?.address?.country)} 
              </>
            }
          />
        </InfoFieldBox>
        <InfoFieldBox>
          <InfoField
            loading={isLoadingCompany}
            label="Data de criação"
            content={formatDateTime(selectedCompany?.created_at ?? "")}
          />
        </InfoFieldBox>
        {
          selectedCompany?.hotspots != null && selectedCompany?.hotspots.length > 0 ? 
          <>
            <div className="text-sm text-gray_2 mb-[-25px]">Pontos fixos</div>
            <Map
              style={{ width: "100%", height: "400px" }}
              defaultCenter={{ lat: -17.46, lng: -55.46 }}
              defaultZoom={4}
              mapId={"dashboard_map"}
              reuseMaps
            >
              {selectedCompany.hotspots.map((d: any, i: number) => 
                <HotspotPositionMarker data={d} />
              )}
            </Map>
          </>
          : <></>
        }
      </div>
    </Modal>
  );
};

export default DetailsCompanyModal;
